export const isEmpty = (val) => {
  return val === null || val === undefined || val === "" || (Array.isArray(val) && val.length === 0);
};

export const joinArray = (arr) => {
  if (arr.length === 0) return "";
  if (arr.length === 1) return arr[0];
  if (arr.length === 2) return arr.join(" and ");

  return `${arr.slice(0, -1).join(", ")} and ${arr[arr.length - 1]}`;
};

export const uniqueArray = (arr) => {
  if (!Array.isArray(arr)) return arr;
  return arr.filter((item, index) => arr.indexOf(item) === index);
};

export const getRouteLabel = (route, i18n) => {
  if (!route) return "-";

  const lang = i18n.language || "en";

  if (route === "sea") {
    if (lang.startsWith("ch")) return "海运"; // Chinese
    if (lang === "th" || lang === "th-TH") return "เส้นทางเรือ"; // Thai
    return "sea"; // English (default)
  }

  if (route === "land") {
    if (lang.startsWith("ch")) return "陆运"; // Chinese
    if (lang === "th" || lang === "th-TH") return "เส้นทางบก"; // Thai
    return "land"; // English (default)
  }

  // ถ้ามีค่าอื่นๆ ที่ไม่รู้จัก ให้แสดงค่าดิบ
  return route;
};

export const getTransportationStatusLabel = (transportationStatus, i18n) => {
  if (!transportationStatus) return "-";

  const lang = i18n.language || "en";

  if (transportationStatus === "open") {
    if (lang.startsWith("ch")) return "装柜中"; // Chinese
    if (lang === "th" || lang === "th-TH") return "เปิด"; // Thai
    return "open"; // English (default)
  }

  if (transportationStatus === "close") {
    if (lang.startsWith("ch")) return "装柜好出发"; // Chinese
    if (lang === "th" || lang === "th-TH") return "ปิด"; // Thai
    return "close"; // English (default)
  }

  if (transportationStatus === "delay") {
    if (lang.startsWith("ch")) return "延误 "; // Chinese
    if (lang === "th" || lang === "th-TH") return "ล่าช้า"; // Thai
    return "delay"; // English (default)
  }

  if (transportationStatus === "arrived") {
    if (lang.startsWith("ch")) return "到达"; // Chinese
    if (lang === "th" || lang === "th-TH") return "มาถึง"; // Thai
    return "arrived"; // English (default)
  }
};
